export class BeforeAfterGalleryContent {
  public id: number;
  public title: string;
  public caption: string;
  public text_content: string;
  public tags: string;
  public gallery_id: number;
  public watermark_type: number;
  public watermark_text: string;
  public watermark_font: { name?: string; value?: string };
  public watermark_opacity: number;
  public watermark_placing: number;
  public media_blocks: {
    title?: string;
    thumbnail?: string;
    content_type?: string;
    order?: string;
    image?: string;
  };
  public clinic: { id?: number; address?: string; logo?: string };

  public _selected: boolean;

  constructor(data: any = {}) {
    this.id = data.id || null;
    this.title = data.title || null;
    this.caption = data.caption || null;
    this.gallery_id = data.gallery_id || null;
    this.text_content = data.text_content || null;
    this.tags = data.tags || null;
    this.media_blocks = data.media_blocks || null;
    this.watermark_type = data.watermark_type || null;
    this.watermark_text = data.watermark_text || null;
    this.watermark_font = data.watermark_font || { name: 'Helvetica Neue', value: 'helvetica' };
    this.watermark_opacity = data.watermark_opacity || null;
    this.watermark_placing = data.watermark_placing || 'top-left';
    this.clinic = data.clinic || {};
    this._selected = data._selected || null;
  }
}
